import productType from "../../constants/productType";

//Constant
export const ADD_CART = "ADD_CART";
export const ADD_CART_FROM_API = "ADD_CART_FROM_API";
export const CLEAR_CART = "CLEAR_CART";
export const CLEAR_CART_REGULAR = "CLEAR_CART_REGULAR";
export const CLEAR_CART_PRE_ORDER = "CLEAR_CART_PRE_ORDER";
export const DELETE_CART = "DELETE_CART";
export const DELETE_CART_PRE_ORDER = "DELETE_CART_PRE_ORDER";
export const ADD_CART_PRE_ORDER = "ADD_CART_PRE_ORDER";
export const ADD_CART_PRE_ORDER_FROM_API = "ADD_CART_PRE_ORDER_FROM_API";
export const CART_QUANTITY_UPDATE = "CART_QUANTITY_UPDATE";
export const CART_PRODUCT_UPDATE = "CART_PRODUCT_UPDATE";
export const CART_PRODUCT_UPDATE_PRE_ORDER = "CART_PRODUCT_UPDATE_PRE_ORDER";
export const BOGO_UPDATE = "BOGO_UPDATE";
// export const UPDATE_CART_MAX_QUATITY = "UPDATE_CART_MAX_QUATITY"

// initial state

const cartInitial = {
  count: 0,
  items: [],
  preItems: [],
  updatedAt: null,
};
const initialState = {
  ...cartInitial,
};

export const CartRducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case BOGO_UPDATE:
      return {
        ...state,
        items: updateBogoCartItem(state.items),
        preItems: updateBogoCartItem(state.preItems),
        updatedAt: Date.now(),
      };
    case ADD_CART:
      var items = state?.items ? [...state?.items] : [];
      var preItems = state?.preItems ? [...state?.preItems] : [];
      var count = state.count + 1;
      items.push(payload);
      // Calculate orderType based on current cart contents
      var orderType =
        preItems?.length > 0 && items?.length > 0
          ? "all-order"
          : preItems?.length > 0
          ? "pre-order"
          : "regular";
      return {
        ...state,
        count,
        items: updateBogoCartItem(items),
        preItems: updateBogoCartItem(preItems),
        orderType,
      };
    case ADD_CART_PRE_ORDER:
      items = state?.items ? [...state?.items] : [];
      preItems = updateBogoCartItem(state?.preItems ? [...state?.preItems] : []);
      count = state.count + 1;
      preItems.push(payload);
      // Calculate orderType based on current cart contents
      orderType =
        preItems?.length > 0 && items?.length > 0
          ? "all-order"
          : preItems?.length > 0
          ? "pre-order"
          : "regular";
      return {
        ...state,
        count,
        items: updateBogoCartItem(items),
        preItems: updateBogoCartItem(preItems),
        orderType,
      };
    case ADD_CART_FROM_API:
      var newItem = state?.items ? [...state?.items] : [];
      count = state.count;
      var index = newItem.findIndex(
        (item) =>
          (!payload.isAccessories &&
            payload.bottomName === item.bottomName &&
            payload.topName === item.topName &&
            payload._id === item._id) ||
          (payload.isAccessories && payload._id === item._id)
      );
      if (index === -1) {
        newItem.push(payload);
        count = count + payload.quantity || 1;
      } else {
        if (payload.cartId) {
          newItem[index].cartId = payload.cartId;
        }
      }
      return { ...state, items: newItem, count: count };
    case ADD_CART_PRE_ORDER_FROM_API:
      newItem = state?.preItems ? [...state?.preItems] : [];
      count = state.count;
      index = newItem.findIndex(
        (item) =>
          (!payload.isAccessories &&
            payload.bottomName === item.bottomName &&
            payload.topName === item.topName &&
            payload._id === item._id) ||
          (payload.isAccessories && payload._id === item._id)
      );
      if (index === -1) {
        newItem.push(payload);
        count = count + payload.quantity;
      }
      return { ...state, preItems: newItem, count: count };

    case CART_PRODUCT_UPDATE:
      // console.log(payload)
      const totalCount =
        (payload?.cartItem?.length || 0) + (payload?.preItem?.length || 0);
      // Calculate orderType based on current cart contents
      const updateOrderType =
        (payload?.preItem?.length || 0) > 0 &&
        (payload?.cartItem?.length || 0) > 0
          ? "all-order"
          : (payload?.preItem?.length || 0) > 0
          ? "pre-order"
          : "regular";
      return {
        ...state,
        items: updateBogoCartItem([...payload?.cartItem]),
        preItems: updateBogoCartItem([...payload?.preItem]),
        count: totalCount,
        orderType: updateOrderType,
      };
    // case CART_PRODUCT_UPDATE_PRE_ORDER:
    //   return { ...state, preItems: payload.items, count: count , orderType:"pre-order"};

    case CART_QUANTITY_UPDATE:
      const { cartItem, quantity } = payload;

      // check it is preitems or not
      const selectCartType = payload?.pre ? state.preItems : state.items;
      var data = selectCartType.map((item) => {
        if (
          cartItem.isAccessories &&
          item?._id === cartItem?._id &&
          item.style === cartItem.style
        ) {
          item = { ...item, quantity: quantity };
          return item;
        } else if (
          !cartItem?.isAccessories &&
          item?._id === cartItem?._id &&
          ((cartItem?.part === productType.fullSet &&
            item?.part === productType.fullSet &&
            item?.topSizing?.size?._id === cartItem?.topSizing?.size?._id &&
            item?.bottomSizing?.size?._id ===
              cartItem?.bottomSizing?.size?._id) ||
            (cartItem?.part === productType.top &&
              item?.part === productType.top &&
              item?.topSizing?.size._id === cartItem?.topSizing?.size?._id) ||
            (cartItem?.part === productType.bottom &&
              item?.part === productType.bottom &&
              item?.bottomSizing?.size._id ===
                cartItem?.bottomSizing?.size?._id))
        ) {
          item = { ...item, quantity: quantity };
          return item;
        }
        return item;
      });
      return {
        ...state,
        [payload.pre ? "preItems" : "items"]: updateBogoCartItem(data),
        updatedAt: Date.now(),
      };

    case DELETE_CART:
      var count1 = state?.count - (payload?.quantity || 1);
      data = state.items.filter((item) => {
        const { bottomName, topName, topSizing, bottomSizing, _id } = item;
        if (_id !== payload?._id) {
          return item;
        } else if (!payload.isAccessories) {
          if (
            _id !== payload?._id ||
            (!bottomName &&
              (topSizing?.size._id !== payload?.topSizing?.size?._id ||
                payload?.bottomName)) ||
            (!topName &&
              (bottomSizing?.size?._id !== payload?.bottomSizing?.size?._id ||
                payload?.topName)) ||
            (bottomName &&
              topName &&
              (topSizing?.size._id !== payload?.topSizing?.size?._id ||
                bottomSizing?.size?._id !== payload?.bottomSizing?.size?._id))
          ) {
            return item;
          }
        } else {
          if (payload.style !== item.style) {
            return item;
          }
        }
      });
      // Calculate orderType after deleting regular item
      const deleteRegularOrderType =
        state.preItems?.length > 0 && data?.length > 0
          ? "all-order"
          : state.preItems?.length > 0
          ? "pre-order"
          : "regular";
      return {
        ...state,
        count: count1,
        items: data,
        orderType: deleteRegularOrderType,
      };
    case DELETE_CART_PRE_ORDER:
      count1 = state.count - (payload?.quantity || 0);
      data = state.preItems.filter((item) => {
        const { bottomName, topName, topSizing, bottomSizing, _id } = item;
        if (_id !== payload?._id) {
          return item;
        } else if (!payload.isAccessories) {
          if (
            _id !== payload?._id ||
            (!bottomName &&
              (topSizing?.size._id !== payload?.topSizing?.size?._id ||
                payload?.bottomName)) ||
            (!topName &&
              (bottomSizing?.size?._id !== payload?.bottomSizing?.size?._id ||
                payload?.topName)) ||
            (bottomName &&
              topName &&
              (topSizing?.size._id !== payload?.topSizing?.size?._id ||
                bottomSizing?.size?._id !== payload?.bottomSizing?.size?._id))
          ) {
            return item;
          }
        }
      });
      // Calculate orderType after deleting pre-order item
      const deletePreOrderOrderType =
        data?.length > 0 && state.items?.length > 0
          ? "all-order"
          : data?.length > 0
          ? "pre-order"
          : "regular";
      return {
        ...state,
        count: count1,
        preItems: data,
        orderType: deletePreOrderOrderType,
      };
    case CLEAR_CART_REGULAR:
      const clearRegularOrderType =
        state.preItems?.length > 0 ? "pre-order" : "regular";
      return {
        ...state,
        count: state.preItems.length,
        items: [],
        orderType: clearRegularOrderType,
      };
    case CLEAR_CART_PRE_ORDER:
      const clearPreOrderOrderType =
        state.items?.length > 0 ? "regular" : "regular";
      return {
        ...state,
        count: state.items.length,
        preItems: [],
        orderType: clearPreOrderOrderType,
      };
    case CLEAR_CART:
      return { ...initialState, ...cartInitial };
    // case UPDATE_CART_MAX_QUATITY:
    //   return {...state, cartQuantityLimit: payload};
    default: {
      return { ...state };
    }
  }
};

export const updateBogo = () => {
  return {
    type: BOGO_UPDATE,
  };
};

// functions
export const addItemToCart = (item) => {
  return {
    type: ADD_CART,
    payload: item,
  };
};

export const addItemToCartPreOrder = (item) => {
  return {
    type: ADD_CART_PRE_ORDER,
    payload: item,
  };
};

export const addItemToCartPreOrderFromApi = (item) => {
  return {
    type: ADD_CART_PRE_ORDER_FROM_API,
    payload: item,
  };
};

export const addItemToCartFromApi = (item) => {
  return {
    type: ADD_CART_FROM_API,
    payload: item,
  };
};

export const updateCartProductStore = (item) => {
  return {
    type: CART_PRODUCT_UPDATE,
    payload: item,
  };
};

// export const updatePreOrder = (item) => {
//   return {
//     type: CART_PRODUCT_UPDATE_PRE_ORDER,
//     payload: item,
//   };
// };

export const cartItemQuantityUpdate = (item, quantity, pre) => {
  return {
    type: CART_QUANTITY_UPDATE,
    payload: { cartItem: item, quantity, pre },
  };
};

export const deleteItemFromCart = (item) => {
  return {
    type: DELETE_CART,
    payload: item,
  };
};

export const deleteItemFromCartPreOrder = (item) => {
  return {
    type: DELETE_CART_PRE_ORDER,
    payload: item,
  };
};

export const clearAllItemFromCart = () => {
  return {
    type: CLEAR_CART,
  };
};
export const clearAllItemFromRegular = () => {
  return {
    type: CLEAR_CART_REGULAR,
  };
};
export const clearAllItemFromPreOrder = () => {
  return {
    type: CLEAR_CART_PRE_ORDER,
  };
};

const updateBogoCartItem = (data) => {
  const bogoConfig = JSON.parse(localStorage.getItem("BOGO") || "{}");
  // console.log("bogoConfig =====> ", bogoConfig);

  var items = [...data];
  items = items.map((product) => {
    const initialPrice =
      product?.part === productType.fullSet
        ? product?.price
        : product?.[product?.part?.toLowerCase() + "Price"];
    let discountedPrice = initialPrice;
    let discountGot = 0;
    let totalDiscountGot = 0;
    let totalPrice = initialPrice * (product?.quantity || 1);
    let totalDiscountedPrice = initialPrice * (product?.quantity || 1);

    if (product.haveDiscount) {
      discountGot = (initialPrice * product.discount) / 100;
      discountedPrice = initialPrice - discountGot;
      totalDiscountedPrice = discountedPrice * (product?.quantity || 1);
      totalDiscountGot = discountGot * (product?.quantity || 1);
    }
    return {
      ...product,
      bogo: false,
      initialPrice, //actual price
      totalPrice, // price for all quantity
      discountedPrice, //price after discount
      totalDiscountedPrice, //price after discount for all quantity
      discountGot, // discount for single quantity
      totalDiscountGot, // discount for all quantity
      bogoQuantity: 0,
    };
  });
  // console.log("bogo config => ", bogoConfig);
  if (!bogoConfig?.isOn) {
    return items;
  } else {
    // summing total price without bogo
    let totalPriceWithoutBogo = 0;
    items
      .filter((product) => product.catSubId !== bogoConfig.reference)
      .map((product) => {
        totalPriceWithoutBogo += +product.totalDiscountedPrice;
      });
    // find total free items
    let totalFreeItemGet = Math.floor(
      totalPriceWithoutBogo / bogoConfig.rewardThreshold
    );
    // finding sorted bogo items
    let bogoItems = items
      .filter((product) => product.catSubId === bogoConfig.reference)
      .sort((a, b) => a.discountedPrice - b.discountedPrice);
    // console.log(
    //   "bogo items => ",
    //   bogoItems,
    //   "total free item get => ",
    //   totalFreeItemGet,
    //   "total price without bogo => ",
    //   totalPriceWithoutBogo
    // );
    bogoItems = bogoItems.map((product) => {
      const productQuantity = Number(product.quantity || 1);
      if (totalFreeItemGet) {
        if (product.quantity <= totalFreeItemGet) {
          product.bogoQuantity = productQuantity;
          totalFreeItemGet = +totalFreeItemGet - +productQuantity;
        } else {
          product.bogoQuantity = totalFreeItemGet;
          totalFreeItemGet = 0;
        }
      }
      const actualQuantity = productQuantity - product.bogoQuantity;
      const initialPrice = product.initialPrice;

      let discountedPrice = initialPrice;
      let discountGot = 0;
      let totalDiscountGot = 0;
      let totalPrice = initialPrice * actualQuantity;
      let totalDiscountedPrice = initialPrice * actualQuantity;

      if (product.haveDiscount) {
        discountGot = (initialPrice * product.discount) / 100;
        discountedPrice = initialPrice - discountGot;
        totalDiscountedPrice = discountedPrice * actualQuantity;
        totalDiscountGot = discountGot * actualQuantity;
      }

      return {
        ...product,
        bogo: !!product.bogoQuantity,
        initialPrice, //actual price
        totalPrice, // price for all quantity
        discountedPrice, //price after discount
        totalDiscountedPrice, //price after discount for all quantity
        discountGot, // discount for single quantity
        totalDiscountGot, // discount for all quantity
      };
    });
    // console.log("===== bogo is on ========", {
    //   totalPriceWithoutBogo,
    //   totalFreeItemGet,
    //   bogoItems,
    // });
    return items.map((product) => {
      const bogoProduct = bogoItems.find((data) => data._id === product._id);
      if (bogoProduct) return bogoProduct;
      return product;
    });
  }
};

// export const updateCartQuantityLimit = (payload=10) => {
//   return {
//     type: UPDATE_CART_MAX_QUATITY,
//     payload
//   };
// };

// //Constant
// export const ADD_CART = "ADD_CART";
// export const ADD_CART_FOR_PRE_ORDER = "ADD_CART_FOR_PRE_ORDER";
// export const ADD_CART_WITH_ORDER_AND_PRE_ORDER =
//   "ADD_CART_WITH_ORDER_AND_PRE_ORDER";
// export const CLEAR_CART = "CLEAR_CART";
// export const DELETE_SINGLE_CART = "DELETE_SINGLE_CART";

// export const ADD_CART_FROM_API = "ADD_CART_FROM_API";
// export const CLEAR_CART_REGULAR = "CLEAR_CART_REGULAR";
// export const CLEAR_CART_PRE_ORDER = "CLEAR_CART_PRE_ORDER";
// export const DELETE_CART_PRE_ORDER = "DELETE_CART_PRE_ORDER";
// export const ADD_CART_PRE_ORDER = "ADD_CART_PRE_ORDER";
// export const ADD_CART_PRE_ORDER_FROM_API = "ADD_CART_PRE_ORDER_FROM_API";
// export const DELETE_CART = "DELETE_SINGLE_CART";

// // initial state
// const initialState = {
//   count: 0,
//   items: [],
//   preItems: [],
//   orderType: "",
// };

// export const CartRducer = (state = initialState, action) => {
//   const { type, payload } = action;
//   switch (type) {
//     case ADD_CART: {
//       let flag = true;
//       const { items } = state;
//       const newItem = items.map((item) => {
//         const { product, topSizing, bottomSizing } = item || {};
//         if (
//           product._id === payload.product?._id &&
//           (payload.product?.isAccessories ||
//             (!payload.product?.isAccessories &&
//               topSizing === payload.topSizing &&
//               bottomSizing === payload.bottomSizing))
//         ) {
//           item.quantity = item.quantity + 1;
//           flag = false;
//         }
//         return item;
//       });
//       if (flag) {
//         newItem.push(payload);
//       }
//       return { ...state, items: newItem };
//     }
//     case ADD_CART_FOR_PRE_ORDER: {
//       let flag = true;
//       const { preItems } = state;
//       const newItem = preItems.map((item) => {
//         const { product, topSizing, bottomSizing } = item || {};
//         if (
//           product._id === payload.product?._id &&
//           (payload.product?.isAccessories ||
//             (!payload.product?.isAccessories &&
//               topSizing === payload.topSizing &&
//               bottomSizing === payload.bottomSizing))
//         ) {
//           item.quantity = item.quantity + 1;
//           flag = false;
//         }
//         return item;
//       });
//       if (flag) {
//         newItem.push(payload);
//       }
//       return { ...state, preItems: newItem };
//     }
//     case ADD_CART_WITH_ORDER_AND_PRE_ORDER:
//       // payload conatain preItem and items
//       return { ...state, ...payload };

//     // case DELETE_CART:
//     //   var count1 = state.count - (payload?.quantity || 0);
//     //   var data = state.items.filter((item) => {
//     //     if (item._id !== payload._id) {
//     //       return item;
//     //     } else {
//     //       if (!payload.isAccessories) {
//     //         if (
//     //           item?.topSizing?.size._id !== payload?.topSizing?.size._id ||
//     //           item?.bottomSizing?.size._id !== payload?.bottomSizing?.size._id
//     //         ) {
//     //           return item;
//     //         }
//     //       }
//     //     }
//     //   });
//     //   return { ...state, count: count1, items: data };
//     // case DELETE_CART_PRE_ORDER:
//     //   var count1 = state.count - (payload?.quantity || 0);
//     //   var data = state.preItems.filter((item) => {
//     //     if (item._id !== payload._id) {
//     //       return item;
//     //     } else {
//     //       if (!payload.isAccessories) {
//     //         if (
//     //           item?.topSizing?.size._id !== payload?.topSizing?.size._id ||
//     //           item?.bottomSizing?.size._id !== payload?.bottomSizing?.size._id
//     //         ) {
//     //           return item;
//     //         }
//     //       }
//     //     }
//     //   });
//     //   return { ...state, count: count1, preItems: data };
//     // case CLEAR_CART_REGULAR:
//     //   return {
//     //     count: state.preItems.length,
//     //     preItems: state.preItems,
//     //     items: [],
//     //   };
//     // case CLEAR_CART_PRE_ORDER:
//     //   return { count: state.items.length, items: state.items, preItems: [] };
//     case CLEAR_CART:
//       return initialState;
//     default: {
//       return state;
//     }
//   }
// };

// // functions
// export const addItemToCart = (item) => {
//   return {
//     type: ADD_CART,
//     payload: item,
//   };
// };

// export const addItemToCartPreOrder = (item) => {
//   return {
//     type: ADD_CART_FOR_PRE_ORDER,
//     payload: item,
//   };
// };

// export const deleteItemFromCart = (item) => {
//   return {
//     type: DELETE_SINGLE_CART,
//     payload: item,
//   };
// };

// export const clearAllItemFromCart = () => {
//   return {
//     type: CLEAR_CART,
//   };
// };
// export const clearAllItemFromRegular = () => {
//   return {
//     type: CLEAR_CART_REGULAR,
//   };
// };
// export const clearAllItemFromPreOrder = () => {
//   return {
//     type: CLEAR_CART_PRE_ORDER,
//   };
// };
